module.exports = __webpack_public_path__ + "assets/media/file.a311f0eb.mp3";